const initialNotification = {
  isBusy: false,
  totalRecordsCount: undefined,
  totalUnreadUserNotificationsCount: undefined,
  records: [],
};

export default initialNotification;
